import { GetUserOrgDepsQuery } from 'gql/graphql';
import { AzureFeatureFlagValue } from './azure-feature-flags';
import { validationCallbackPerCondition } from './utils';

// Type representing the organization from GetUserOrgDepsQuery.
type OrganizationFromQuery = NonNullable<GetUserOrgDepsQuery['organization']>;

function shouldEnableFlag({
  flag,
  data,
}: {
  flag: AzureFeatureFlagValue;
  data: { organization?: OrganizationFromQuery | null };
}) {
  // If there are no conditions, then we should enable the flag
  if (!flag.conditions?.client_filters?.length || !flag.enabled) {
    return flag.enabled;
  }

  // If there are conditions, then we should enable the flag if any of the conditions are met
  const shouldEnable = flag.conditions.client_filters.some(
    (condition) =>
      validationCallbackPerCondition[condition.name]?.({
        //@ts-expect-error
        flagId: flag.id,
        condition,
        data,
      }) ?? flag.enabled,
  );

  return shouldEnable;
}

export { shouldEnableFlag };
